export default {"src":"/_next/static/media/default-profile.aecfc2ae.svg","height":66,"width":66,"blurWidth":0,"blurHeight":0};